module.exports = __webpack_public_path__ + "7bd046032e85e966542e97614a6425ed.png";